import axios, { AxiosRequestConfig } from 'axios';
import { useToken } from '../contexts/tokenContext';

export const useChangePassword = () => {
	const token = useToken();
	return async (form: any): Promise<any> => {
		try {
			if (!token?.accessToken) {
				return null;
			}

			const params: AxiosRequestConfig = {
				method: 'POST',
				url: '/password/change',
				data: form,
				withCredentials: true,
			};
			const result = await axios.request(params);
			return result.data;
		} catch (error) {
			throw error;
		}
	};
};
